import { Link } from 'react-router-dom';
import { featuredVideos } from '@/mocks/videos';

export default function FeaturedVideos() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                精选推荐
              </h2>
              <p className="text-sm text-foreground-500 mt-2">
                编辑精选 · 品质保证
              </p>
            </div>
            <Link
              to="/category/hot"
              className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer inline-flex items-center gap-1 transition-colors"
            >
              查看全部
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {featuredVideos.map((video) => (
              <Link
                key={video.id}
                to={`/category/${video.category}`}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full aspect-video overflow-hidden">
                  <img
                    src={video.cover}
                    alt={video.title}
                    title={`${video.title} - 宅男视频高清在线观看`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2 py-1 bg-primary-500 text-white text-xs font-medium rounded-md whitespace-nowrap">
                      {video.quality}
                    </span>
                  </div>
                  <div className="absolute bottom-3 right-3">
                    <span className="px-2 py-1 bg-black/70 text-white text-xs rounded-md whitespace-nowrap">
                      {video.duration}
                    </span>
                  </div>
                  <div className="absolute top-3 right-3">
                    <span className="px-2 py-1 bg-accent-500/90 text-foreground-900 text-xs font-medium rounded-md whitespace-nowrap">
                      {video.source}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 mb-2">
                    {video.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
                    {video.description}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <div className="flex items-center gap-1">
                      <div className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                      </div>
                      <span className="font-medium text-foreground-700">{video.rating}</span>
                    </div>
                    <span className="whitespace-nowrap">{video.updateInfo}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}